export const ACCESS_TOKEN = 'access_token'
export const REFRESH_TOKEN = 'refresh_token'

export const SKIP_ACCOUNT_CONNECTION = 'skip_account_connection'

export const SECTION_ORDER = 'section_order'
export const DASHBOARD_LAYOUT_SWAPPED = 'dashboard_layout_swapped'
export const SMALL_WIDGETS_ORDER = 'small_widgets_order'
export const BIG_WIDGETS_ORDER = 'big_widgets_order'
export const MEDIUM_WIDGETS_ORDER = 'medium_widgets_order'

export const TRADING_TABLE_COLUMNS_ORDER = 'trading_table_columns_order'
export const TRIGGERED_AUTO_UPLOAD = 'triggeredAutoUpload'

export const LOCAL_STORAGE_ACTIVE_TOUR_KEY = 'joyride-active-tour'
export const LOCAL_STORAGE_ACTIVE_STEP_KEY = 'joyride-active-step'

export const ADMIN_DASHBOARD_PERIOD = 'admin_dashboard_period'
export const ADMIN_DASHBOARD_COMPARE_PERIOD = 'admin_dashboard_compare_period'
export const ADMIN_DASHBOARD_COMPARE_SHORTCUT = 'admin_dashboard_compare_shortcut'
export const QUESTIONNAIRE_ANALYTICS_PERIOD = 'questionnaire_analytics_period'
export const LINK_CLICK_ANALYTICS_PERIOD = 'link_click_analytics_period'
export const ACTIVATION_FUNNEL_PERIOD = 'activation_funnel_period'
export const FEATURE_USAGE_PERIOD = 'feature_usage_period'
export const ADMIN_EVENTS_PERIOD = 'admin_events_period'
export const CHURN_SIGNALS_PERIOD = 'churn_signals_period'
export const ACTIVATION_FUNNEL_STALLED_AFTER_DAYS = 'activation_funnel_stalled_after_days'
export const LINK_CLICK_ANALYTICS_SELECTED_LINK = 'link_click_analytics_selected_link'
export const ADMIN_DASHBOARD_ACCOUNT_FILTERS = 'admin_dashboard_account_filters'
export const USER_DASHBOARD_PERIOD = 'user_dashboard_period'

export const PERIOD_SHORTCUT = 'period_shortcut'

export const CURRENT_ACCOUNT_ID = 'current_account_id'

export const IS_SIDE_MENU_WIDE = 'is_side_menu_wide'
export const IS_SIDE_MENU_OPEN = 'is_side_menu_open'

export const AI_MARKET_INSIGHTS_SELECTED_PAIR = 'ai_market_insights_selected_pair'
export const AI_MARKET_INSIGHTS_FAVORITE_PAIRS = 'ai_market_insights_favorite_pairs'
